export default "__VITE_ASSET__111437e4__"